/* AC Premium product add-to-cart — one global handler for home and product pages.
 * Loaded from theme.liquid, not from a section script that the theme editor may replace.
 */
(() => {
  if (window.__acPremiumAddToCartV2) return;
  window.__acPremiumAddToCartV2 = true;

  const base = () => {
    const root = window.Shopify?.routes?.root || '/';
    return root.endsWith('/') ? root : root + '/';
  };

  const cartUrl = () => (window.routes && window.routes.cart_url) || base() + 'cart';

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('.ac-product__form')) return;
    event.preventDefault();
    event.stopImmediatePropagation();

    const section = form.closest('.ac-product');
    const button = form.querySelector('.ac-product__add');
    if (!section || !button || button.dataset.acSubmitting === 'true') return;

    const variant = Number(form.querySelector('input[name="id"]')?.value);
    const offer = section.querySelector('input[type="radio"][name^="ac-quantity-"]:checked');
    const qtyField = form.querySelector('input[name="quantity"]');
    const quantity = Math.max(1, parseInt(offer?.value || qtyField?.value || '1', 10) || 1);

    if (!Number.isSafeInteger(variant) || variant <= 0) {
      console.error('[AC Cart] Missing variant ID');
      window.alert("Ce produit n'a pas de variante valide. Vérifiez la sélection du produit.");
      return;
    }

    button.dataset.acSubmitting = 'true';
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');

    try {
      const response = await fetch(base() + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variant, quantity })
      });
      const data = await response.json().catch(() => null);
      if (!response.ok || data?.status) {
        const message = data?.description || data?.message || 'La boutique a refusé cet ajout.';
        console.error('[AC Cart] Shopify add rejected:', response.status, data);
        window.alert(message);
        return;
      }

      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.renderContents === 'function') {
        try {
          const htmlResponse = await fetch(base() + 'cart?section_id=cart-drawer', {
            credentials: 'same-origin', cache: 'no-store'
          });
          if (!htmlResponse.ok) throw new Error('Cart section HTTP ' + htmlResponse.status);
          const html = await htmlResponse.text();
          if (!html.includes('CartDrawer-CartItems')) throw new Error('Cart section markup missing');
          await drawer.renderContents({ id: variant, sections: { 'cart-drawer': html } });
          return;
        } catch (drawerError) {
          console.error('[AC Cart] Drawer rendering failed:', drawerError);
        }
      }
      window.location.assign(cartUrl());
    } catch (error) {
      console.error('[AC Cart] Network or JavaScript failure:', error);
      window.alert("L'ajout au panier a échoué. Veuillez réessayer.");
    } finally {
      delete button.dataset.acSubmitting;
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  }, true);
})();
